import { useEffect, useState } from 'react';
import { Plus } from 'lucide-react';
import * as dashboardApi from '../api/dashboard-api';
import { TextInputDialog } from './TextInputDialog';
import { Badge } from '@/design-system';
import type { Tag } from '@/contracts/funnel';

export interface TagFilterProps {
  selectedTagId: string | null;
  onSelect: (tagId: string | null) => void;
}

/** SPEC-003 §29-30/T042: list/select tags as a filter, plus quick-create. */
export function TagFilter({ selectedTagId, onSelect }: TagFilterProps) {
  const [tags, setTags] = useState<Tag[]>([]);
  const [createOpen, setCreateOpen] = useState(false);

  useEffect(() => {
    dashboardApi.listTags().then((res) => setTags(res.items));
  }, []);

  async function reload() {
    const res = await dashboardApi.listTags();
    setTags(res.items);
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5" role="group" aria-label="Filtrar por etiqueta">
      {tags.map((tag) => (
        <button key={tag.id} type="button" onClick={() => onSelect(selectedTagId === tag.id ? null : tag.id)}>
          <Badge tone={selectedTagId === tag.id ? 'brand' : 'neutral'}>{tag.name}</Badge>
        </button>
      ))}
      <button
        type="button"
        aria-label="Criar etiqueta"
        onClick={() => setCreateOpen(true)}
        className="rounded p-0.5 text-text-muted hover:text-accent"
      >
        <Plus size={14} />
      </button>

      <TextInputDialog
        open={createOpen}
        title="Criar etiqueta"
        label="Nome da etiqueta"
        submitLabel="Criar"
        onClose={() => setCreateOpen(false)}
        onSubmit={async (name) => {
          await dashboardApi.createTag(name);
          await reload();
        }}
      />
    </div>
  );
}
